var DOWN_ARROW, ENTER, ESCAPE, KEYLIST, Keypress, LEFT_ARROW, RIGHT_ARROW, TAB, UP_ARROW, base, base1, isCharKeyPress, isDownArrowKey, isEnterKey, isEscapeKey, isTabKey, isUpArrowKey, isValidCharKeyPress, isValidKeyPress, whichKeyAlias;

TAB = 9;

ENTER = 13;

ESCAPE = 27;

DOWN_ARROW = 40;

RIGHT_ARROW = 39;

UP_ARROW = 38;

LEFT_ARROW = 37;

KEYLIST = {
  9: 'Tab',
  13: 'Enter',
  27: 'Escape',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown'
};

isTabKey = function(key) {
  return key === TAB;
};

isEnterKey = function(key) {
  return key === ENTER;
};

isEscapeKey = function(key) {
  return key === ESCAPE;
};

isUpArrowKey = function(key) {
  return key === UP_ARROW;
};

isDownArrowKey = function(key) {
  return key === DOWN_ARROW;
};


/**
 * Assert if key pressed is a normal character key
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key pressed is a normal character key
 */

isValidCharKeyPress = function(e) {
  if (e.which == null) {
    return false;
  }
  if (!isCharKeyPress(e)) {
    return false;
  }
  if (!isValidKeyPress(e.which)) {
    return false;
  }
  return true;
};


/**
 * Assert if key code is valid
 * and wasn't pressed with extra control keys
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key wasn't pressed with control keys
 */

isCharKeyPress = function(e) {
  if (typeof e.which === 'number' && e.which > 0) {
    return !e.ctrlKey && !e.metaKey && !e.altKey;
  }
  return false;
};


/**
 * Assert if key code is a navigational key
 *
 * @param   {Number}  key - Key code
 * @returns {Boolean}     - Assert if key is not a navigational key
 */

isValidKeyPress = function(key) {
  return !(key === TAB || key === ENTER || key === ESCAPE || key === UP_ARROW || key === DOWN_ARROW || key === LEFT_ARROW || key === RIGHT_ARROW);
};


/**
 * Returns the key name according to the Keyboard API specs
 * NOTE: e.key is not supported in Safari thus fallback to alias list
 *
 * @param   {Object} e - jQuery event
 * @returns {String}   - Key name
 */

whichKeyAlias = function(e) {
  return e.key || KEYLIST[e.which] || '';
};

module.exports = Keypress = {
  isCharKeyPress: isCharKeyPress,
  isDownArrowKey: isDownArrowKey,
  isEnterKey: isEnterKey,
  isEscapeKey: isEscapeKey,
  isTabKey: isTabKey,
  isUpArrowKey: isUpArrowKey,
  isValidCharKeyPress: isValidCharKeyPress,
  isValidKeyPress: isValidKeyPress,
  whichKeyAlias: whichKeyAlias
};

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).Common == null) {
  base1.Common = {};
}

_.extend(window.Groupon.Modules.SearchBar.Common, {
  Keypress: Keypress
});

